module.exports = __webpack_public_path__ + "static/assets/321222cd9e714617cac45e847858274c.jpg";